const update_service = state => state.update_service;

export {
    update_service
}
